import { use } from 'react'
import { CzListSetsContext } from './CzListSetsContext'

export function useCzListSetsContext() {
  const context = use(CzListSetsContext)

  if (!context) {
    throw new Error('useCzListSetsContext must be used within a CzListSetsProvider')
  }

  return context
}
